import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await fetch(`${API}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(formatApiErrorDetail(data.detail));
      login(data.token, data.user);
      navigate("/admin");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-wrap" data-testid="admin-login-page">
      <form className="login-card" onSubmit={onSubmit}>
        <a className="brand login-brand" href="/" data-testid="admin-login-brand">
          <span className="mark">KOS-LAB</span>
          <span>
            KOSS 2027
            <small>ORGANISING TEAM ACCESS</small>
          </span>
        </a>
        <h1 className="login-title">Team sign in.</h1>
        <p className="login-sub">Private area for reviewing delegate applications.</p>
        {error && (
          <div className="notice err" role="alert" data-testid="admin-login-error">
            {error}
          </div>
        )}
        <div className="field">
          <label htmlFor="admin-email">Email address</label>
          <input
            id="admin-email"
            type="email"
            required
            autoComplete="email"
            placeholder="you@koslab.ng"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="admin-login-email-input"
          />
        </div>
        <div className="field">
          <label htmlFor="admin-password">Password</label>
          <input
            id="admin-password"
            type="password"
            required
            autoComplete="current-password"
            placeholder="Your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="admin-login-password-input"
          />
        </div>
        <button className="btn login-btn" type="submit" disabled={loading} data-testid="admin-login-submit-btn">
          {loading ? "Signing in…" : "Sign in →"}
        </button>
        <p className="hint">Access is limited to the KOS-Lab organising team.</p>
      </form>
    </div>
  );
}
